import React from 'react';
import moment from 'moment';
import Modal from './Modal';
import shopperPayoutService from '../../services/shopperPayoutService';

const SummaryRow = ({ label, value }) => (
  <div className='flex items-center justify-between px-4 py-3'>
    <span className='text-sm text-gray-600'>{label}</span>
    <span className='text-sm font-semibold text-gray-900'>{value}</span>
  </div>
);

/**
 * "Confirm Import Bulk" dialog — the last stop before the payouts are actually
 * processed. Only rows marked valid are processed by the backend.
 */
const ConfirmImportModal = ({
  isOpen,
  batch,
  onBack,
  onConfirm,
  submitting = false,
}) => {
  if (!batch) return null;

  const uploadedAt = batch.uploadedAt
    ? moment(batch.uploadedAt).format('DD MMM YYYY HH:mm')
    : '-';

  return (
    <Modal isOpen={isOpen} onClose={submitting ? undefined : onBack}>
      <div className='p-6'>
        <h2 className='text-xl font-bold text-gray-900'>Confirm Import Bulk</h2>
        <p className='mt-1 text-sm text-gray-600'>
          Please review the information below before processing.
        </p>

        <div className='mt-5 border border-gray-200 rounded-lg divide-y divide-gray-100'>
          <SummaryRow
            label='Total Shopper Payout'
            value={shopperPayoutService.formatCount(batch.totalRows)}
          />
          <SummaryRow
            label='Valid'
            value={shopperPayoutService.formatCount(batch.validRows)}
          />
          <SummaryRow
            label='Invalid'
            value={shopperPayoutService.formatCount(batch.invalidRows)}
          />
          <SummaryRow label='Uploaded By' value={batch.uploadedByName || '-'} />
          <SummaryRow label='Uploaded At' value={uploadedAt} />
        </div>

        <div className='mt-5 flex items-start gap-3 bg-blue-50 rounded-lg px-4 py-3'>
          <svg
            className='w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5'
            fill='none'
            stroke='currentColor'
            viewBox='0 0 24 24'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={2}
              d='M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
            />
          </svg>
          <p className='text-sm text-blue-700'>
            Only valid data result will be processed.
            <br />
            Invalid result will not be processed.
          </p>
        </div>

        <div className='mt-6 flex items-center justify-between'>
          <button
            type='button'
            onClick={onBack}
            disabled={submitting}
            className='border border-gray-300 text-gray-700 px-5 py-2.5 rounded-md text-sm font-medium hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed'
          >
            Back
          </button>
          <button
            type='button'
            onClick={onConfirm}
            disabled={submitting}
            className='bg-blue-600 text-white px-6 py-2.5 rounded-md text-sm font-medium hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed'
          >
            {submitting ? 'Processing...' : 'Confirm Import'}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmImportModal;
